"use strict";

var _regeneratorRuntime = require("@babel/runtime/regenerator");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionManager = void 0;

var PollingBlockTracker = require("eth-block-tracker");

var createSubscriptionManager = require("eth-json-rpc-filters/subscriptionManager");

var noop = function noop() {};

var SubscriptionManager = /*#__PURE__*/function () {
  function SubscriptionManager(provider) {
    _classCallCheck(this, SubscriptionManager);

    var blockTracker = new PollingBlockTracker({
      provider: provider,
      pollingInterval: 15 * 1000,
      setSkipCacheFlag: true
    });

    var _createSubscriptionMa = createSubscriptionManager({
      blockTracker: blockTracker,
      provider: provider
    }),
        events = _createSubscriptionMa.events,
        middleware = _createSubscriptionMa.middleware;

    this.events = events;
    this.subscriptionMiddleware = middleware;
  }

  _createClass(SubscriptionManager, [{
    key: "handleRequest",
    value: function () {
      var _handleRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                result = {};
                _context.next = 3;
                return this.subscriptionMiddleware(request, result, noop, noop);

              case 3:
                return _context.abrupt("return", result);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleRequest(_x) {
        return _handleRequest.apply(this, arguments);
      }

      return handleRequest;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      this.subscriptionMiddleware.destroy();
    }
  }]);

  return SubscriptionManager;
}();

exports.SubscriptionManager = SubscriptionManager;